import type { Descendant, Element } from 'slate';

export const encodeFragment = (fragment: Descendant[]) =>
  btoa(encodeURIComponent(JSON.stringify(fragment)));

export const decodeFragment = (fragmentString: string) =>
  JSON.parse(decodeURIComponent(atob(fragmentString))) as Element[];
